import React from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileAlt, faShapes, faCrayon, faBrain, faGlobe, faCog, faPalette, faDashboard, faFaceSmile } from '@fortawesome/free-solid-svg-icons';
import touchbookimage from '../../assets/pageimages/TouchBook.webp';
import { faPagelines } from '@fortawesome/free-brands-svg-icons';

const TouchBookHome = () => {
    const authState = useSelector(state => state.authReducer);
    const userName = authState.user.name;

    return (
        <MainLayout>
        <div className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 min-h-screen p-4 sm:p-8 mt-12">
            <h2 className='text-xl lg:text-2xl font-bold text-white text-center'>
                TouchBooks for All
            </h2>

            {/* TouchBook Image Section */}
            <div className="flex justify-center mt-2 sm:mt-4 relative">
                <img
                    id="touchbook-id"
                    src={touchbookimage}
                    alt="My Touch Book Image"
                    style={{width:'300px', height: 'auto'}}
                    className="w-full h-auto max-w-xs md:max-w-sm lg:max-w-md xl:max-w-lg rounded-lg shadow-md"
                />
                <h2 className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-yellow-200 text-m sm:text-xl font-semibold text-center">
                    {userName}'s Touch Book <br className="hidden sm:block"/> on Think5Whys
                </h2>
            </div>

            {/* Digital Notepads Links */}
            <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-5 gap-2 mt-4 text-sm lg:text-m">
                <Link 
                    to='/notes-canvas' 
                    className="bg-lime-600 p-2 rounded-lg shadow-lg text-center hover:bg-lime-500 transition duration-300"                >
                    <FontAwesomeIcon className="mr-2 sm:mr-4 text-xl sm:text-xl" icon={faFileAlt} />  
                    Notepad for All
                </Link>
                <Link 
                    to='/stencils-canvas' 
                    className="bg-lime-600 p-2 rounded-lg shadow-lg text-center hover:bg-lime-500 transition duration-300"
                >
                    <FontAwesomeIcon className="mr-2 sm:mr-4 text-xl sm:text-xl" icon={faShapes} />  
                    Children Stencils
                </Link>
                <Link 
                    to='/coloring-canvas' 
                    className="bg-lime-600 p-2 rounded-lg shadow-lg text-center hover:bg-lime-500 transition duration-300"
                >
                    <FontAwesomeIcon className="mr-2 sm:mr-4 text-xl sm:text-xl" icon={faPalette} />  
                    Children Coloring
                </Link>
                <Link 
                    to='/liveworksheets-canvas' 
                    className="bg-lime-600 p-2 rounded-lg shadow-lg text-center hover:bg-lime-500 transition duration-300"
                >
                    <FontAwesomeIcon className="mr-2 sm:mr-4 text-xl sm:text-xl" icon={faPagelines} />  
                    Live Worksheets
                </Link>
                <Link 
                    to='/science-canvas' 
                    className="bg-lime-600 p-2 rounded-lg shadow-lg text-center hover:bg-lime-500 transition duration-300"
                >
                    <FontAwesomeIcon className="mr-2 sm:mr-4 text-xl sm:text-xl" icon={faBrain} />  
                    Science
                </Link>
                <Link 
                    to='/geography-canvas' 
                    className="bg-lime-600 p-2 rounded-lg shadow-lg text-center hover:bg-lime-500 transition duration-300"
                >
                    <FontAwesomeIcon className="mr-2 sm:mr-4 text-xl sm:text-xl" icon={faGlobe} />  
                    Geography
                </Link>
                <Link 
                    to='/industry-canvas' 
                    className="bg-lime-600 p-2 rounded-lg shadow-lg text-center hover:bg-lime-500 transition duration-300"
                >
                    <FontAwesomeIcon className="mr-2 sm:mr-4 text-xl sm:text-xl" icon={faCog} />  
                    Industry
                </Link>
                <Link 
                    to='/leisure-canvas' 
                    className="bg-lime-600 p-2 rounded-lg shadow-lg text-center hover:bg-lime-500 transition duration-300"
                >
                    <FontAwesomeIcon className="mr-2 sm:mr-4 text-xl sm:text-xl" icon={faFaceSmile} />  
                    Leisures
                </Link>
            </div>


            {/* Dashboard Button */}
            {/* <div className="flex justify-center mt-8">
                <Link 
                    to='/dashboard' 
                    className="bg-blue-600 p-2 rounded-lg shadow-lg text-center hover:bg-blue-500 transition duration-300"
                >
                    <FontAwesomeIcon className="mr-2 sm:mr-4" icon={faDashboard} />  
                    Go to Dashboard
                </Link>
            </div> */}
        </div>
    </MainLayout>
    );
};

export default TouchBookHome;
